import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../../../apps/frontend/src/context/ThemeStore';

import PercentileCardLight from '../../../../../apps/frontend/public/img/percentile-card-light.svg';
import PercentileCardDark from '../../../../../apps/frontend/public/img/percentile-card-dark.svg';
import PercentileCardMobileDark from '../../../../../apps/frontend/public/img/percentile-card-mobile-dark.svg';
import PercentileCardMobileLight from '../../../../../apps/frontend/public/img/percentile-card-mobile-light.svg';

import ProjectedPercentileCardLight from '../../../../../apps/frontend/public/img/projected-percentile-card-light.svg';
import ProjectedPercentileCardDark from '../../../../../apps/frontend/public/img/projected-percentile-card-dark.svg';
import ProjectedPercentileCardMobileDark from '../../../../../apps/frontend/public/img/projected-percentile-card-mobile-dark.svg';
import ProjectedPercentileCardMobileLight from '../../../../../apps/frontend/public/img/projected-percentile-card-mobile-light.svg';

import QuizrrLight from '../../../public/Images/QuizrrWhite.svg';
import QuizrrBlack from '../../../public/Images/QuizrrBlack.svg';
import QuizrrLogoLight from '../../../public/Images/QuizrrLogoLight.svg';
import QuizrrLogoDark from '../../../public/Images/QuizrrLogoDark.svg';
import { SparkleIcon } from '@phosphor-icons/react';

const PercentileCard = ({ percentileData, score, percentile, isProjected = false }) => {
  const isSubjectPercentilePresent = percentile?.subjectWisePercentile?.length > 0;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    // Set initial state
    setIsMobile(mediaQuery.matches);

    // Listener for changes
    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return (
    <div
      className="h-[258px] md:max-w-[496px] md:w-full rounded-xl flex-1 lg:flex-initial lg:min-w-0 flex-shrink-0"
      style={{
        backgroundImage: `url(${
          isMobile
            ? isProjected
              ? ProjectedPercentileCardMobileLight
              : PercentileCardMobileLight
            : isProjected
              ? ProjectedPercentileCardLight
              : PercentileCardLight
        })`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
        backgroundSize: 'auto 100%',
      }}
    >
      <div className={`flex flex-col justify-between h-full ${isProjected ? 'py-6' : 'py-3'} px-4`}>
        {/* Top Content */}
        <div>
          {isProjected && <img src={QuizrrBlack} alt="Quizrr Logo" className="h-[80px] w-[80px]" />}
          <div
            className={`text-sm md:text-base flex flex-row items-center gap-1 mt-4 ${isProjected ? 'text-[var(--q3-teal-normal)]' : 'text-[var(--q3-indigo-normal)] font-bold'} whitespace-nowrap`}
          >
            {isProjected ? (
              <SparkleIcon size={isMobile ? 16 : 20} weight="fill" />
            ) : (
              <img src={QuizrrLogoLight} alt="Quizrr Logo" className="-mt-1.5" />
            )}
            {isProjected ? 'Potential' : 'Predicted'}{' '}
            {percentileData?.combinedScore || percentile?.combinedScore === 'null' ? 'Rank' : 'Percentile'}
          </div>
          {percentile?.data && (
            <p
              className={`md:text-[88px] text-5xl font-black ${!isProjected ? 'text-[var(--q3-indigo-normal)]' : 'text-[var(--q3-teal-normal)]'} pt-0 md:pt-3`}
            >
              {Number(percentile?.data) ? Number(percentile?.data)?.toFixed(2) : percentile?.data}
            </p>
          )}
          {/* {!percentile?.combinedScore && percentile?.data && !isProjected && (
            <p className="text-xs text-[var(--q3-neutral-light)]">Exact Percentile: {percentile?.data}%ile</p>
          )} */}
          {!percentile?.data && <p className="text-xs max-w-[280px] mt-8">{percentileData?.consolationText}</p>}

          {isSubjectPercentilePresent && (
            <div className="flex flex-row items-center justify-start gap-5 my-3 md:mt-6">
              {percentile.subjectWisePercentile.map((subject) => (
                <div key={subject?.subject?.title} className="flex flex-col items-start justify-center">
                  <p className="text-[10px] text-[var(--q3-neutral-light)]">{subject?.subject?.title}</p>
                  <p className="text-[10px] md:text-xs text-[var(--q3-neutral-light)] font-bold">
                    {Number(subject?.percentile?.data)
                      ? `${subject?.percentile?.title ? `${subject?.percentile?.title} ` : ''} ${Number(subject?.percentile?.data)?.toFixed(2)}%ile`
                      : `${subject?.percentile?.title ? `${subject?.percentile?.title} ` : ''} ${subject?.percentile?.data}%ile`}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Bottom Description */}
        <p className="text-xs text-[var(--q3-neutral-default)] mt-3 md:mt-0">
          {!isProjected
            ? extractData(percentileData?.description)
              ? `Prediction is done based on ${extractData(percentileData?.description)} data`
              : percentileData?.description
            : 'This is your Potential Percentile, calculated using patterns from JEE Main 2025 data'}
        </p>
      </div>
    </div>
  );
};

export default PercentileCard;

function extractData(text) {
  const regex = /JEE Main \d{4} \(\d{1,2} [A-Za-z]+ Shift \d+\)/;
  const match = text?.match(regex);
  return match ? match[0] : null;
}
